import { render } from "./UsedCarsSales.vue?vue&type=template&id=6d38cb4c&scoped=true"
import script from "./UsedCarsSales.vue?vue&type=script&lang=js"
export * from "./UsedCarsSales.vue?vue&type=script&lang=js"

import "./UsedCarsSales.vue?vue&type=style&index=0&id=6d38cb4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d38cb4c"]])

export default __exports__